// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-verso -> rebel-residential-verso -> verso
// Generated: 2026-09-11T19:20:25.749Z
// Counts: 0 design, 38 content, 31 slot group, 1 collection binding, 5 section, 2 style

export const designOverrides = {};

export const contentOverrides = {
  "amenities-blurb.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 32px;\">Community &amp; Apartment Amenities</span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 32px;\">Everything you need is right here.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.bandHeading": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 32px;\">Urban Living At Its Finest</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 32px;\">Community comforts and features to enjoy.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-blurb.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 32px;\">Apply Now</span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-blurb.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 32px;\">Frequently Asked Questions</span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 32px;\">Explore Our Apartment Floor Plans</span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 40px;\">Discover your new home layout.</span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-blurb.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 32px;\">Photo Gallery</span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Gallery</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.pre_title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-blurb.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 32px;\">Explore the Community Map</span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore the Neighborhood</h2><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodintro.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 32px;\">Apartments in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3><span style=\"font-size: 32px;\">Explore <span data-type=\"field-token\" data-field=\"property_name\"></span>’s Neighborhood</span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodtour.section_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3><span style=\"font-size: 32px;\">Tour the neighborhood.</span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-blurb.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 32px;\">Our Pet-Friendly Policy</span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h3>Experience The Difference</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 40px;\">Live Where You Love</span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 40px;\">Apartments in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-blurb.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 32px;\">Resident Resources</span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-blurb.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Resident Reviews</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 32px;\">Schedule Your Tour Today</span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "tabbedcallouts.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_amenities_blurb"
  },
  "tabbedcallouts.section_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 40px;\">Discover Amenities</span></h2><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2><span style=\"font-size: 32px;\">Take a Virtual Tour</span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo."
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      }
    }
  },
  "floorplanslist.card_image_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-b52c-71ec-b645-0b1c59aade80.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with stainless steel appliances, white cabinets, and quartz countertops."
      }
    }
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-c0a3-7590-8bbc-87c0c763f367.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with a coffee table, TV, and bookshelves."
      }
    }
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-b53f-72ce-a894-17b6d37552ee.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Luxurious living room with large windows and plush seating."
      }
    }
  },
  "floorplanslist.card_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-df15-720c-bb6f-b3f185462057.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern living room with a TV showing a yoga pose, a guitar, and stylish furniture."
      }
    }
  },
  "floorplanslist.card_image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-e857-708e-9dee-498a3c2257f2.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with stainless steel appliances and white cabinets."
      }
    }
  },
  "hyperlocalexplore.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-b53f-72ce-a894-17b6d37552ee.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Luxurious living room with large windows and plush seating."
      }
    }
  },
  "hyperlocalexplore.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-ec69-76bf-a45a-82cfc6f9c1ba.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern gym with punching bag, weight machines, treadmills, and exercise bikes."
      }
    }
  },
  "hyperlocalexplore.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-b539-71b9-ae2e-cc177c33c10b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Rooftop lounge area with comfortable seating and city views."
      }
    }
  },
  "manualfloorplans.plan_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a62-6012-746e-9181-35f94a5ef3cd.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Studio-style bedroom with a queen bed, desk, and dresser."
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Studio"
      },
      "beds": {
        "type": "GENERATOR",
        "generatedValue": "Studio"
      },
      "baths": {
        "type": "GENERATOR",
        "generatedValue": "1"
      },
      "sqft": {
        "type": "GENERATOR",
        "generatedValue": "560"
      }
    }
  },
  "manualfloorplans.plan_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-b53f-72ce-a894-17b6d37552ee.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "One-bedroom living room with large windows and plush seating."
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "One Bedroom"
      },
      "beds": {
        "type": "GENERATOR",
        "generatedValue": "1"
      },
      "baths": {
        "type": "GENERATOR",
        "generatedValue": "1"
      },
      "sqft": {
        "type": "GENERATOR",
        "generatedValue": "720"
      }
    }
  },
  "manualfloorplans.plan_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a62-6137-7701-b100-3c49adf37f05.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two-bedroom kitchen and dining area with island seating."
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Two Bedroom"
      },
      "beds": {
        "type": "GENERATOR",
        "generatedValue": "2"
      },
      "baths": {
        "type": "GENERATOR",
        "generatedValue": "2"
      },
      "sqft": {
        "type": "GENERATOR",
        "generatedValue": "1050"
      }
    }
  },
  "manualfloorplans.plan_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-df15-720c-bb6f-b3f185462057.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Three-bedroom living room with a large TV and natural light."
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Three Bedroom D1"
      },
      "beds": {
        "type": "GENERATOR",
        "generatedValue": "3"
      },
      "baths": {
        "type": "GENERATOR",
        "generatedValue": "2"
      },
      "sqft": {
        "type": "GENERATOR",
        "generatedValue": "1280"
      }
    }
  },
  "neighborhoodtour.day_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-d175-75cc-970d-c63cbcb8f957.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Highland Bakery Downtown"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cafe & Bakery"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Southern-style cafe & bakery offering all-day breakfast, salads & sandwiches, plus fresh pastries."
      }
    }
  },
  "neighborhoodtour.day_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-2a89-735d-99a9-bc82c4a3b7bd.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Ponce City Market"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Shopping & Retail"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "0.3 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Vibrant converted historic Sears building, now a market with a food hall, shops & living space."
      }
    }
  },
  "neighborhoodtour.day_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-f3a1-727a-ad8e-b2b7494805cf.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Historic Fourth Ward Park"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Nature & Outdoor Attractions"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "A 17-acre park with a splash fountain, skate park & amphitheater, adjacent to the Atlanta Beltline."
      }
    }
  },
  "neighborhoodtour.day_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-c8d0-717d-8afc-4a5f72ce9210.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Krog Street Market"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Restaurants"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "1.2 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Independent food stalls fill this market that was built in the 1920s & is now a popular hangout."
      }
    }
  },
  "neighborhoodtour.night_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-c936-77ae-82a8-6ad369badcae.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Ticonderoga Club"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Bar & Cocktails"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "1.2 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Colonial era–inspired tavern serving seafood, sandwiches & craft cocktails at Krog Street Market."
      }
    }
  },
  "neighborhoodtour.night_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-e287-73ef-a780-3ce85984d812.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Variety Playhouse"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Entertainment"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Converted movie theater now serves as an intimate concert hall featuring a variety of popular acts."
      }
    }
  },
  "neighborhoodtour.night_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-d11b-712b-84ee-7d788f8ee007.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Kevin Rathbun Steak"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Steakhouse"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "1.0 mi"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Modern chophouse featuring steaks & seafood in a dimly lit converted warehouse with a chic feel."
      }
    }
  },
  "neighborhoodtour.night_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a64-cf5a-76cd-9bfa-d43084df013a.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "BeetleCat"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Oyster Bar & Lounge"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Upscale oyster bar & cocktail lounge featuring globally inspired seafood & custom drinks."
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-b532-7343-b3cb-0dbd30763ec0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen area with coffee station and island, overlooking pool."
      }
    }
  },
  "pinnedcallouts.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-b9a4-7384-ac8c-5d71a4dd476c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "A family sits on the grass outside a building, enjoying a conversation."
      }
    }
  },
  "propertyoverview.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167734/01a03a61-b539-71b9-ae2e-cc177c33c10b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Rooftop lounge area with comfortable seating and city views."
      }
    }
  },
  "tabbedcallouts.amenity_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "a resort‑style pool"
      }
    }
  },
  "tabbedcallouts.amenity_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "a dedicated dog park"
      }
    }
  },
  "tabbedcallouts.amenity_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "pet‑washing station"
      }
    }
  },
  "tabbedcallouts.amenity_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Fitness center with yoga studio"
      }
    }
  },
  "tabbedcallouts.amenity_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Skyline rooftop lounge & clubroom"
      }
    }
  },
  "tabbedcallouts.amenity_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "On-site dining & BeltLine access"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "gallerytabs.images": {
    "limit": null,
    "hiddenIds": [
      "ec_96bb932a42931c15f43a6b9b",
      "ec_3f02cf885aa90f8e4a5c7759",
      "ec_d4d62bb5afab70bbd41bca22",
      "ec_12ac131411853ea8f4439722",
      "ec_46633852c283022453da6f56",
      "ec_4332d391ae06528746f0f292",
      "ec_ed93b4d97997a3aa1fbf955a",
      "ec_0270bab6d3a1e19d6a403379",
      "ec_1fa02218c00bbb767c6aa836",
      "ec_a9445cb257e8298f168d3b65",
      "ec_f6a278d0b691abb2e9851dc5",
      "ec_c3ff1b877d3e410e345feb63",
      "ec_59becd78c89957789b40ff94",
      "ec_c75dba86a97fc6ae39c09180"
    ],
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    }
  ]
};

export const styleOverrides = {
  "tabbedcallouts.body": {
    "properties": {
      "color": "#262b22"
    }
  },
  "tabbedcallouts.section_heading": {
    "properties": {
      "color": "#262b22"
    }
  }
};
